(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Home.Client",
            {
                url: "/Client/{clientId}",
                component: "client",
                resolve: {
                    client: ["clientApi", "advisorApi", "$stateParams", function (clientApi, advisorApi, $stateParams) {
                        return clientApi.get($stateParams.clientId);
                    }],
                    primaryAdvisor: ["clientApi", "client", function (clientApi, client) {
                        return clientApi.getPrimaryAdvisor(client.Id).catch(ng.noop);
                    }]
                },
                redirectTo: "Home.Client.Activity"
            });
    }]);

    app.component("client",
        {
            transclude: true,
            templateUrl: "/App/Client/client-template.html",
            controller: clientController,
            bindings: {
                currentUser: "<",
                parentUsers: "<",
                client: "<",
                primaryAdvisor: "<"
            }
        });

    clientController.$inject = ["$transitions", "$rootScope", "moment"];
    function clientController($transitions, $rootScope, moment) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    Dob: null
                }
            });

        $ctrl.$onInit = () => {
            $ctrl.ui.Dob = $ctrl.client.Person.Dob ? moment.utc($ctrl.client.Person.Dob).format("ll") : null;
        }

        $transitions.onStart({ to: "**", from: "**" },
            function (trans) {
                var from = trans.from();

                if (from.name.startsWith("Home.Client"))
                    $rootScope.$emit("loadingClientSubstate");
            });
    }

})(window.app, window.angular); // jshint ignore:line